export default __webpack_public_path__ + "static/sc-policy2-f7f454b0dc151f0c4e7af896716f3ce1.webp";